import Form from '../ht-form/index.js';

class SignupForm extends Form {

}

export default SignupForm;